import React, { useCallback, useMemo } from "react";
import 'survey-core/defaultV2.min.css';
import { Model } from 'survey-core';
import { Survey as SurveyUI } from 'survey-react-ui';

import { SurveyResultModel } from "../../models/SurveyResultModel";
import { useNavigate, useOutletContext } from "react-router-dom";
import { OutletContextModel } from "../../models/OutletContextModel";
import { addDocument, getCollection } from "../../core/firebase/firebaseFirestore";
import { getQuestionsArray } from "../../core/db/questionsFunctions";
import { QueryDocumentSnapshot } from "firebase/firestore";
import { useMutation, useQuery } from "@tanstack/react-query";

import emailjs from "@emailjs/browser";

import './Survey.css';

const minRateDesc = { default: 'Completamente en desacuerdo' }
const maxRateDesc = { default: 'Completamente de acuerdo' }
const rateMin = 1;
const rateMax = 5;
const required = true;
const surveyTitle = 'Niveles de madurez en los subsistemas de la organización';
const pagetitle = 'Refiriendose a la empresa en que colabora, Califica del 1 al 5 siendo 5 completamente de acuerdo y 1 completamente en desacuerdo';
// const completedText = '<h3>La encuesta ha terminado, gracias por tu participación</h3>';

const resultsCollectionName = 'results';
const questionsCollectionName = 'questions';

const surveyJson = {
    // "completedHtml": completedText,
    title: surveyTitle,
    pages: [
        {
            title: pagetitle,
            name: "page1",
            elements: []
        }
    ],
    showPrevButton: false,
    showQuestionNumbers: "onpage",
    completeText: {
        default: "Terminar"
    },
    widthMode: "static",
    width: "1200px"
}

const SERVICE_ID = "service_fau9sl5";
const TEMPLATE_ID = "template_u7oua6j";

const Survey = () => {
    const outletContext: OutletContextModel = useOutletContext();

    const navigate = useNavigate();

    // const questionsArray = getQuestionsArray();

    const { data: questionsArray } = useQuery({
        queryKey: ['questionsData'],
        queryFn: () => getQuestions()
    });

    const getQuestions = useCallback(async () => {
        const response = await getCollection(questionsCollectionName);
        const questions = mapQuestions(response?.docs);
        return questions;
    }, []);

    const mapQuestions = (firebaseSnapshots: QueryDocumentSnapshot[] | undefined) => {
        if (firebaseSnapshots) {
            const list = firebaseSnapshots[0].data().list;
            return list;
        }
        return [];
    }

    const mapSurveyJson = () => {
        // @ts-ignore
        surveyJson.pages[0].elements = questionsArray?.map((item) => {
            const surveyElement = {
                type: 'rating',
                title: {
                    default: item.text
                },
                rateMin: rateMin,
                rateMax: rateMax,
                minRateDescription: minRateDesc,
                maxRateDescription: maxRateDesc,
                name: String(item.index),
                isRequired: required,
                requiredErrorText: "Debe seleccionar una opción"
            }
            return ((process.env.NODE_ENV === 'production') ? { ...surveyElement } : { ...surveyElement, defaultValue: Math.ceil(Math.random() * 5) });

        });

        return surveyJson;
    }

    const survey = useMemo(() => new Model(mapSurveyJson()), [questionsArray]);

    survey.applyTheme(outletContext.theme);

    survey.onComplete.add(
        useCallback(async (sender: Model) => {
            const results = sender.data;
            survey.clear();
            saveResults.mutate(results);
            await onSendEmail();
        }, [navigate, survey])
    );

    const formatSurveyResults = (unformatedAnswers: any): SurveyResultModel => {
        return {
            timestamp: Date.now(),
            answers: Object.values(unformatedAnswers),
            hasContactData: false
        }
    }

    const onSaveResults = async (results: any) => {
        let formattedResults = formatSurveyResults(results);
        const requestReponse = await addDocument(resultsCollectionName, formattedResults);

        return [requestReponse, formattedResults];
    }

    const onSendEmail = async () => {
        await emailjs.send(SERVICE_ID, TEMPLATE_ID, {});
    }

    const saveResults = useMutation({
        mutationFn: onSaveResults,
        onSuccess: (returnedValue) => {
            const [requestReponse, formattedResults] = returnedValue;
            if (requestReponse) {
                // @ts-ignore
                let documentId = requestReponse?.id;
                navigate(
                    '/resultado-diagnostico',
                    {
                        state: {
                            data: formattedResults,
                            type: 'partial',
                            documentId
                        }
                    }
                );
            }
        }
    });

    return (
        <div className="full-height-container">
            {/* <button onClick={() => onSendEmail()}>Send Test email</button> */}
            <SurveyUI model={survey} />
        </div>
    );
}

export default Survey;